import type { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Add auth headers to all API requests
  if (req.url.startsWith('/api/')) {
    // ✅ No need to manually add Authorization header!
    // The HttpOnly cookies will be automatically sent with the request
    // Just ensure credentials are included

    const authReq = req.clone({
      withCredentials: true // ✅ This ensures cookies are sent
    });

    return next(authReq);
  }

  return next(req);
};